module.exports = __webpack_public_path__ + "img/icon-message-outline.4670aafc.svg";